// React
import React, { FC } from "react";

// Components
import Tooltip from "HOC/Tooltip";
import Pill from "Components/Pill";

// Classes
import { AttributeObject } from "../classes/attributes.classes";

// Styling
import injectSheet from "react-jss";
import styleSheet from "./styles";

interface PillProps {
  classes?: any;
  text?: string;
  groupCount?: string;
  attribute?: AttributeObject;
}

const SimplePill: FC<PillProps> = (props: any) => {
  return (
    <div className={props.classes.pillContainerHorizontal}>
      <Pill text={props.text} />
    </div>
  );
};

export default injectSheet(styleSheet)(SimplePill);
